const MESSAGES: Record<string, string> = {
  unauthorized: 'Нужно войти',
  forbidden: 'Нет доступа',
  email_taken: 'Этот email уже занят',
  invalid_credentials: 'Неверный email или пароль',
  company_name_required: 'Укажите название компании',
  invite_code_required: 'Укажите invite-код',
  company_not_found: 'Компания с таким кодом не найдена',
  wishlist_not_found: 'Список не найден',
  item_not_found: 'Айтем не найден',
  share_not_found: 'Ссылка устарела или неверна',
  user_not_found: 'Пользователь не найден в компании',
  user_outside_company: 'Можно шарить только коллегам из своей компании',
  cannot_share_self: 'Нельзя выдать доступ самому себе',
  owner_cannot_reserve: 'Владелец не бронирует свои подарки',
  owner_cannot_pledge: 'Владелец не оставляет взносы на свой список',
  already_reserved: 'Уже забронировано кем-то другим',
  validation_error: 'Проверьте поля формы',
  not_found: 'Не найдено',
  request_failed: 'Запрос не выполнен',
}

export function humanError(code: string): string {
  return MESSAGES[code] || code
}
